<ideal-punchout-integration-list-view
  [customerNumber]="activeCustomerNumber()"
  [integrations]="integrations()"
  (itemClicked)="onIntegrationClicked($event)"
/>
